import React, { useState, useContext, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../comum/Context/auth";
import { api } from "../../services/api";
import { setLoginToday } from "./../../app/Utils/auth.js";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import firebase from "../Config/firebase";
import "firebase/compat/auth";

import logoSmall from "../../comum/assets/arbor.png";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";

import "./index.css";

function Login() {
  const navigate = useNavigate();

  const emailRef = useRef(null);
  const senhaRef = useRef(null);

  const { setLogado } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  function LoginUsuario() {
    setErro("");
    firebase
      .auth()
      .signInWithEmailAndPassword(email, senha)
      .then(() => {
        PesquisarRestaurante();
      })
      .catch(() => {
        setErro("E-mail ou senha inválidos.");
      });
  }

  function PesquisarRestaurante() {
    api
      .get("/restaurante/cadastro/" + email)
      .then((retorno) => {
        const codigoRest = retorno.data[0]?.codigo;
        if (codigoRest) {
          setLoginToday(null, null, null, codigoRest);
          localStorage.removeItem("chapa");
          setLogado(true);
          setSucesso(true);
        } else {
          setErro("Esse e-mail não está associado a um restaurante.");
        }
      })
      .catch(() => {
        setErro("Esse e-mail não está associado a um restaurante.");
      });
  }

  useEffect(() => {
    if (sucesso) {
      navigate("/restaurante/pedido");
    }
  }, [sucesso, navigate]);

  return (
    <div>
      <Menu modulo="RESTAURANTE" />

      <div className="d-flex align-items-center text-center form-container">
        <form className="form-signin" onSubmit={(e) => e.preventDefault()}>
          <img className="img-login" src={logoSmall} alt="Arbor Web" />

          <div className="form-floating">
            <input
              type="email"
              id="floatingInput"
              className="form-control"
              placeholder="E-mail"
              value={email}
              ref={emailRef}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  senhaRef.current?.focus();
                }
              }}
            />
            <label htmlFor="floatingInput">E-mail</label>
          </div>

          <div className="form-floating">
            <input
              type={showPassword ? "text" : "password"}
              id="floatingPassword"
              className="form-control"
              placeholder="Senha"
              ref={senhaRef}
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && email !== "") {
                  e.preventDefault();
                  LoginUsuario();
                }
              }}
            />
            <label htmlFor="floatingPassword">Senha</label>
            <button
              type="button"
              className="btn-eye-toggle"
              onClick={toggleShowPassword}
              tabIndex="-1"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button
            type="button"
            className="w-100 btn btn-login-restaurante"
            onClick={LoginUsuario}
          >
            Acessar Sistema
          </button>

          {erro && (
            <div className="alert alert-danger mt-3 py-2 px-3 small rounded-3 text-start" role="alert">
              {erro}
            </div>
          )}

          <div className="login-links">
            <Link to="/restaurante/resetsenha" className="link-restaurante">
              Esqueci a Senha
            </Link>
            <span className="text-muted">/</span>
            <Link to="/restaurante/novaconta" className="link-restaurante">
              Cadastrar
            </Link>
          </div>

          <p className="text-copyright">
            &copy; Desenvolvido por F2 Enterprise
          </p>
        </form>
      </div>

      <Footer />
    </div>
  );
}

export default Login;